<template>
  <v-container fluid>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="500"
    >
      <template v-slot:activator="{ on }">
        <v-btn 
          icon 
          x-small
          class="mt-n6"
          v-on="on"
        >
          <v-icon color="primary">
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
    
      <material-card
        :offset="10"
        :full-width="true"
        color="hrissecondary"
        :title="header"
        :text="`Update `+ header"
        class="mb-0"
        :loading="loading"
      >
        <form v-if="dialog && !loading">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                class="pb-0"
              >
                <v-text-field
                  v-if="header==='Employee Epf'"
                  v-model="localStatutory.current_cycle_epf_employee_contributed" 
                  v-money="money"
                  label="Employee Epf"
                  prefix="RM"
                  outlined
                />

                <v-text-field
                  v-else-if="header==='Employer Epf'"
                  v-model="localStatutory.current_cycle_epf_employer_contributed" 
                  v-money="money"
                  label="Employer Epf"
                  prefix="RM"
                  outlined
                />

                <v-text-field
                  v-else-if="header==='Employee Socso'"
                  v-model="localStatutory.current_cycle_socso_employee_contributed" 
                  v-money="money"
                  label="Employee Socso"
                  prefix="RM"
                  outlined
                />

                <v-text-field
                  v-else-if="header==='Employer Socso'"
                  v-model="localStatutory.current_cycle_socso_employer_contributed" 
                  v-money="money"
                  label="Employer Socso"
                  prefix="RM"
                  outlined
                />

                <v-text-field
                  v-else-if="header==='Employee EIS'"
                  v-model="localStatutory.current_cycle_eis_employee_contributed" 
                  v-money="money"
                  label="Employee EIS"
                  prefix="RM"
                  outlined
                />

                <v-text-field
                  v-else-if="header==='Employer EIS'"
                  v-model="localStatutory.current_cycle_eis_employer_contributed" 
                  v-money="money"
                  label="Employer EIS"
                  prefix="RM"
                  outlined
                />

                <v-text-field
                  v-else-if="header==='Employee PCB'"
                  v-model="localStatutory.current_cycle_employee_pcb_paid" 
                  v-money="money"
                  label="Employee PCB"
                  prefix="RM"
                  outlined
                />

                <v-text-field
                  v-else-if="header==='Employer PCB'"
                  v-model="localStatutory.current_cycle_employer_pcb_paid"
                  v-money="money"
                  label="Employer PCB"
                  prefix="RM"
                  outlined
                />

                <v-text-field
                  v-else-if="header==='Employer HRDF'"
                  v-model="localStatutory.employer_hrdf"
                  v-money="money"
                  label="Employer HRDF"
                  prefix="RM"
                  outlined
                />
              </v-col>  
            </v-row>
          </v-container>
        </form> 

        <v-card-actions v-if="dialog && !loading">
          <v-spacer />
          <v-btn
            :disabled="progressing"
            text
            class="px-10"
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            :loading="progressing"
            color="hrissecondary"    
            class="white--text px-10"      
            @click="warningDialog = true"
          >
            Update
          </v-btn>
        </v-card-actions> 
      </material-card>  
    </v-dialog>

    <v-dialog
      v-model="warningDialog"
      persistent
      max-width="500"
    >
      <material-card
        :offset="10"
        :full-width="true"
        color="warning"
        :title="header"
        :text="`Update `+ header"
        class="mb-0"
        :loading="loading"
      > 
        <form v-if="warningDialog && !loading">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                class="pb-0"
              >
                This action will <span class="font-weight-medium">NOT re-compute</span> the selected employee's payroll. Do you want to proceed?
              </v-col> 
            </v-row>
          </v-container>
        </form>

        <v-card-actions v-if="warningDialog && !loading">
          <v-spacer />
          <v-btn
            :disabled="progressing"
            text
            class="px-10"
            @click="warningDialog = false"
          >
            No
          </v-btn>
          <v-btn
            :loading="progressing"
            color="warning"    
            class="white--text px-10"      
            @click="submitForm"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </material-card>   
    </v-dialog>
  </v-container>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      header: {
        type: String,
        required: true,
      },
      statutory: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localStatutory: null,
        loading: false,
        warningDialog: false,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },
    watch: {
      dialog: function (value) {
        this.localStatutory = { ...this.statutory }

        if (this.localStatutory.current_cycle_epf_employee_contributed) { this.localStatutory.current_cycle_epf_employee_contributed = (Math.round((this.localStatutory.current_cycle_epf_employee_contributed / 100) * 100) / 100).toFixed(2) }
        if (this.localStatutory.current_cycle_epf_employer_contributed) { this.localStatutory.current_cycle_epf_employer_contributed = (Math.round((this.localStatutory.current_cycle_epf_employer_contributed / 100) * 100) / 100).toFixed(2) }
        if (this.localStatutory.current_cycle_socso_employee_contributed) { this.localStatutory.current_cycle_socso_employee_contributed = (Math.round((this.localStatutory.current_cycle_socso_employee_contributed / 100) * 100) / 100).toFixed(2) }
        if (this.localStatutory.current_cycle_socso_employer_contributed) { this.localStatutory.current_cycle_socso_employer_contributed = (Math.round((this.localStatutory.current_cycle_socso_employer_contributed / 100) * 100) / 100).toFixed(2) }
        if (this.localStatutory.current_cycle_eis_employee_contributed) { this.localStatutory.current_cycle_eis_employee_contributed = (Math.round((this.localStatutory.current_cycle_eis_employee_contributed / 100) * 100) / 100).toFixed(2) }
        if (this.localStatutory.current_cycle_eis_employer_contributed) { this.localStatutory.current_cycle_eis_employer_contributed = (Math.round((this.localStatutory.current_cycle_eis_employer_contributed / 100) * 100) / 100).toFixed(2) }
        if (this.localStatutory.current_cycle_employee_pcb_paid) { this.localStatutory.current_cycle_employee_pcb_paid = (Math.round((this.localStatutory.current_cycle_employee_pcb_paid / 100) * 100) / 100).toFixed(2) }
        if (this.localStatutory.current_cycle_employer_pcb_paid) { this.localStatutory.current_cycle_employer_pcb_paid = (Math.round((this.localStatutory.current_cycle_employer_pcb_paid / 100) * 100) / 100).toFixed(2) }
        if (this.localStatutory.employer_hrdf) { this.localStatutory.employer_hrdf = (Math.round((this.localStatutory.employer_hrdf / 100) * 100) / 100).toFixed(2) }
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.computationBasicSalary().updateStatutory(this.localStatutory.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')

                  if (this.header === 'Employee Epf') {
                    this.$snack({ message: 'Employee Epf updated' })
                  } else if (this.header === 'Employer Epf') {
                    this.$snack({ message: 'Employer Epf updated' })
                  } else if (this.header === 'Employee Socso') {
                    this.$snack({ message: 'Employee Socso updated' })
                  } else if (this.header === 'Employer Socso') {
                    this.$snack({ message: 'Employer Socso updated' })
                  } else if (this.header === 'Employee EIS') {
                    this.$snack({ message: 'Employee EIS updated' })
                  } else if (this.header === 'Employer EIS') {
                    this.$snack({ message: 'Employer EIS updated' })
                  } else if (this.header === 'Employee PCB') {
                    this.$snack({ message: 'Employee PCB updated' })
                  } else if (this.header === 'Employer PCB') {
                    this.$snack({ message: 'Employer PCB updated' })
                  } else if (this.header === 'Employer HRDF') {
                    this.$snack({ message: 'Employer HRDF updated' })
                  }

                  this.setProgressing(false)
                  this.dialog = false
                  this.warningDialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        if (this.header === 'Employee Epf') {
          return { current_cycle_epf_employee_contributed: this.localStatutory.current_cycle_epf_employee_contributed.toString().replaceAll(',', '') * 100 }
        } else if (this.header === 'Employer Epf') {
          return { current_cycle_epf_employer_contributed: this.localStatutory.current_cycle_epf_employer_contributed.toString().replaceAll(',', '') * 100 }
        } else if (this.header === 'Employee Socso') {
          return { current_cycle_socso_employee_contributed: this.localStatutory.current_cycle_socso_employee_contributed.toString().replaceAll(',', '') * 100 }
        } else if (this.header === 'Employer Socso') {
          return { current_cycle_socso_employer_contributed: this.localStatutory.current_cycle_socso_employer_contributed.toString().replaceAll(',', '') * 100 }
        } else if (this.header === 'Employee EIS') {
          return { current_cycle_eis_employee_contributed: this.localStatutory.current_cycle_eis_employee_contributed.toString().replaceAll(',', '') * 100 }
        } else if (this.header === 'Employer EIS') {
          return { current_cycle_eis_employer_contributed: this.localStatutory.current_cycle_eis_employer_contributed.toString().replaceAll(',', '') * 100 }
        } else if (this.header === 'Employee PCB') {
          return { current_cycle_employee_pcb_paid: this.localStatutory.current_cycle_employee_pcb_paid.toString().replaceAll(',', '') * 100 }
        } else if (this.header === 'Employer PCB') {
          return { current_cycle_employer_pcb_paid: this.localStatutory.current_cycle_employer_pcb_paid.toString().replaceAll(',', '') * 100 }
        } else if (this.header === 'Employer HRDF') {
          return { employer_hrdf: this.localStatutory.employer_hrdf.toString().replaceAll(',', '') * 100 }
        }
      },
    },
  }
</script>
